var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ACFE00",
    d: "M5.571 6.857v10.286h4.295c.99-.107 1.585-.9 1.705-1.856v-2.331c-.043-.665-.385-1.17-1.028-1.359v-.12c.377-.137.523-.433.6-.814V8.666c0-.965-.75-1.809-1.71-1.809zm6.857 0v1.286h1.286V6.857zm3 0v3h-3v7.286h1.286v-6h1.714v6h3v-1.286h-1.714v-4.714h1.714V9.857h-1.714v-3zm-6.21 1.286c.313.077.605.347.639.668v1.856c-.06.292-.351.42-.651.476H6.857v-3zm.493 4.286c.292.072.532.231.575.527v2.267a.765.765 0 0 1-.575.634H6.857V12.43z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBit);
export default __webpack_public_path__ + "static/media/bit.8872f18ef333142cdd44697b687e7df1.svg";
export { ForwardRef as ReactComponent };